export enum RRulePreset {
  EveryDay = 'everyDay',
  EveryWeek = 'everyWeek',
  EveryMonth = 'everyMonth',
  EveryYear = 'everyYear',
  Custom = 'custom',
}
